<template>
  <mu-dialog dialog-class="cardRounded relative" :body-class="modalVisible" @close="toggleVisibility" :open="showModal">
    <div class="outerWrap">
      <div class="contentWrap" v-if="!saved && !rejected">
        <button class="transparent close">
          <mu-icon value="close" class="closeIcon" v-on:click="toggleVisibility"></mu-icon>
        </button>
        <mu-card-text class="title">{{$t('message.usernameInitialModalTitle')}}</mu-card-text>
        <mu-card-text>
          {{$t('message.usernameInitialModalBody')}}
        </mu-card-text>
        <mu-card-text>
          <mu-text-field full-width
                         hint-text="Max. 30 characters"
                         label="Desired Username"
                         v-model="displayName"
                         v-validate
                         :data-vv-rules="'display_name_regex|min:2|max:30'"
                         data-vv-name="displayName"
                         data-vv-value-path="inputValue"
                         :data-vv-as="$t('message.accountPreferencesDisplayName')"
                         :errorText="errors.first('displayName')"
                         :fullWidth="true"
                         :label="$t('message.accountPreferencesDisplayName')">
          </mu-text-field>
        </mu-card-text>
        <mu-card-text>
          {{$t('message.usernameInitialModalTip')}}
        </mu-card-text>
        <mu-card-text>
          <mu-row class="spaceBelow">
            <mu-flat-button class="fullWidth halfRounded btnPrimary btnAction" :primary="true" v-on:click="accept" :disabled="saving">
              {{ saving ? $t('message.savingText') : $t('message.usernameInitialModalSave') }}
            </mu-flat-button>
          </mu-row>
          <mu-row>
            <mu-flat-button class="fullWidth halfRounded btnSecondary btnAction" :secondary="true"
                            v-on:click="reject">{{$t('message.usernameInitialModalReject')}}
            </mu-flat-button>
          </mu-row>
        </mu-card-text>
      </div>

      <div class="contentWrap" v-else-if="saved">
        <mu-card-text class="title">
          <mu-icon value="check" class="circleCheck"></mu-icon>
          {{$t('message.usernameInitialModalConfirmTitle')}}
        </mu-card-text>
        <mu-card-text>
          {{$t('message.usernameInitialModalConfirmBody')}}
        </mu-card-text>
        <mu-card-text>
          <mu-flat-button class="fullWidth halfRounded btnPrimary btnAction" v-on:click="toggleVisibility"
                          :primary="true">
            {{$t('message.labelContinueText')}}
          </mu-flat-button>
        </mu-card-text>
      </div>

      <div class="contentWrap" v-else-if="rejected">
        <mu-card-text class="title">{{$t('message.usernameInitialModalRejectTitle')}}</mu-card-text>
        <mu-card-text>
          {{$t('message.usernameInitialModalRejectBody')}}
        </mu-card-text>
        <mu-card-text>
          <mu-flat-button class="fullWidth halfRounded btnPrimary btnAction" v-on:click="toggleVisibility"
                          :primary="true">
            {{$t('message.labelContinueText')}}
          </mu-flat-button>
        </mu-card-text>
      </div>
    </div>
  </mu-dialog>
</template>

<script>
  import AccountApi from "../../../api/Account";
  import UserManager from "../../../helpers/UserManager";
  export default {
    name: "DisplayNameModal",
    props: [
      'display'
    ],
    data() {
      return {
        displayName: '',
        saved: false,
        saving: false,
        rejected: false,
        showModal: false,
        show_display_name: false
      }
    },
    mounted() {
      const self = this;
      this.$nextTick(() => {
        self.showModal = self.display
      })
    },
    methods: {
      toggleVisibility() {
        const self = this;
        self.showModal = !self.showModal;
        self.saved = false;
        self.rejected = false;
      },
      reject() {
        const self = this;
        self.rejected = true;
        self.show_display_name = false;
        self.submit();
      },
      accept() {
        this.show_display_name = true;
        this.submit()
      },
      submit() {
        const self = this;
        self.$validator.validateAll().then((valid) => {
          if (!valid) {
            return;
          }
          self.saving = true;
          AccountApi.updateDisplayName({
            'display_name': self.displayName,
            'show_display_name': self.show_display_name,
          }).then((response) => {
            self.saved = true;
            self.$store.state.user.scope.accepted_display_name = true;
            UserManager.getUserAndStore(self);
            self.saving = false;
          }).catch((error)=> {
            if (error.response.data && error.response.data.sub_message && error.response.data.sub_message === "DISPLAY_NAME_UNAVAILABLE") {
              self.$toastr.error("Display name unavailable, please choose a different one")
            }
            self.saving = false;
          });
        });

      }
    }
  }

</script>

<style scoped lang="less">

  .modalVisible {
    overflow: hidden;
  }

  .spaceBelow {
    margin-bottom: 15px;
  }

  .transparent {
    background: none;
    border: none;
  }

  .close {
    position: absolute;
    right: 0;
    top: 10px;
    font-size: 1.5rem;
    color: #0179d5;
    cursor: pointer;
  }

  .closeIcon {
    font-size: 2.5rem;
  }

  .btnPrimary {
    background: #0179d5;
    color: #fff;

    &:hover {
      filter: brightness(125%);
    }
  }

  .btnSecondary {
    background: #e5f1fb;
    color: #0179d5;

    &:hover {
      filter: brightness(75%);
    }
  }

  .title {
    font-size: 1.75rem;
    font-weight: 500;
    padding-bottom: 0;
    color: #0179d5;
  }

  .halfRounded {
    border-radius: 4px;
  }

  .fullWidth {
    width: 100%;
  }

  .outerWrap {
    .mu-card-text {
      padding-bottom: 0;

      &:last-of-type {
        padding-bottom: 15px;
      }
    }
  }
</style>
<style lang="less">
  .closeIcon {
    font-size: 2rem;
  }

  .cardRounded {
    border-radius: 8px;
  }

  .relative {
    position: relative;
  }

  .circleCheck {
    color: #fff;
    background: #89c93b;
    border-radius: 50%;
    padding: 2px;
  }
</style>



// WEBPACK FOOTER //
// DisplayNameModal.vue?8077246c